<template>
  <nav class="pr-0 md:pr-4 w-full md:w-auto py-10 md:py-0">
    <ul class="overflow-hidden list-reset flex items-center justify-between md:justify-center md:block">
      <RegisterStepListItem v-bind="stepsConfig.register">
        Create an account
      </RegisterStepListItem>
      <RegisterStepListItem v-bind="stepsConfig.profile">
        Build your profile
      </RegisterStepListItem>
      <RegisterStepListItem v-bind="stepsConfig.jedi">
        Take the J.E.D.I. pledge
      </RegisterStepListItem>
    </ul>
  </nav>
</template>

<script>
import RegisterStepListItem from "./steps/RegisterStepListItem.vue";
export default {
  name: "RegisterPageSteps",
  components: { RegisterStepListItem },
  computed: {
    stepsConfig() {
      const isRegister = this.$route.name === 'register';
      const isProfile = this.$route.name === 'register-create-profile';
      const isJedi = this.$route.name === 'register-jedi-pledge';

      return {
        register: { active: isRegister, completed: isProfile || isJedi, last: false, number: 1, },
        profile: { active: isProfile, completed: isJedi, last: false, number: 2, },
        jedi: { active: isJedi, completed: false, last: true, number: 3, }
      };
    }
  }
}
</script>

<style scoped>
</style>